import { all, call, takeLatest, takeEvery } from 'redux-saga/effects';
import { ActionTypes } from '../constants/index';
import { network } from './network';


export function* getVariantInfo({ payload }) {
  yield call(network, 'variant', 'info',
    ActionTypes.EDITOR_GET_SUCCESS,
    ActionTypes.EDITOR_GET_FAILURE,
    { ...payload }
  );
}

export function* addBlock({ payload }) {
  yield call(network, 'editor', 'block/insert',
    ActionTypes.EDITOR_BLOCK_ADD_SUCCESS,
    ActionTypes.EDITOR_BLOCK_ADD_FAILURE,
    { ...payload }
  );
}

export function* addBlocks({ payload }) {
  yield call(network, 'editor', 'block/insertMulti',
    ActionTypes.EDITOR_BLOCKS_ADD_SUCCESS,
    ActionTypes.EDITOR_BLOCKS_ADD_FAILURE,
    { ...payload }
  );
}

export function* deleteBlock({ payload }) {
  yield call(network, 'editor', 'block/delete',
    ActionTypes.EDITOR_BLOCK_DELETE_SUCCESS,
    ActionTypes.EDITOR_BLOCK_DELETE_FAILURE,
    { ...payload }
  );
}

export function* reorderBlock({ payload }) {
  yield call(network, 'editor', 'block/reorder',
    ActionTypes.EDITOR_BLOCK_REORDER_SUCCESS,
    ActionTypes.EDITOR_BLOCK_REORDER_FAILURE,
    { ...payload }
  );
}

export function* syncBlock({ payload }) {
  yield call(network, 'editor', 'block/sync',
    ActionTypes.EDITOR_BLOCK_SYNC_SUCCESS,
    ActionTypes.EDITOR_BLOCK_SYNC_FAILURE,
    { ...payload },
  );
}

export function* renameBlock({ payload }) {
  yield call(network, 'editor', 'block/rename',
    ActionTypes.EDITOR_BLOCK_RENAME_SUCCESS,
    ActionTypes.EDITOR_BLOCK_RENAME_FAILURE,
    { ...payload },
  );
}

export function* updateColor({ payload }) {
  yield call(network, 'editor', 'color/update',
    ActionTypes.EDITOR_COLOR_UPDATE_SUCCESS,
    ActionTypes.EDITOR_COLOR_UPDATE_FAILURE,
    { ...payload }
  );
}

export function* updateFont({ payload }) {
  yield call(network, 'editor', 'font/update',
    ActionTypes.EDITOR_FONT_UPDATE_SUCCESS,
    ActionTypes.EDITOR_FONT_UPDATE_FAILURE,
    { ...payload }
  );
}

export function* updateSeo({ payload }) {
  yield call(network, 'editor/seo/update',
    ActionTypes.EDITOR_SEO_UPDATE_SUCCESS,
    ActionTypes.EDITOR_SEO_UPDATE_FAILURE,
    { ...payload },
  );
}

export function* updateAnalytics({ payload }) {
  yield call(network, 'editor', 'analytics/update',
    ActionTypes.EDITOR_GID_UPDATE_SUCCESS,
    ActionTypes.EDITOR_GID_UPDATE_FAILURE,
    { ...payload },
  );
}

export function* publish({ payload }) {
  yield call(network, 'editor', 'publish',
    ActionTypes.EDITOR_PUBLISH_SUCCESS,
    ActionTypes.EDITOR_PUBLISH_FAILURE,
    { ...payload },
  );
}

export default function* root() {
  yield all([
    takeLatest(ActionTypes.EDITOR_GET_REQUEST, getVariantInfo),
    takeEvery(ActionTypes.EDITOR_BLOCK_ADD_REQUEST, addBlock),
    takeLatest(ActionTypes.EDITOR_BLOCKS_ADD_REQUEST, addBlocks),
    takeLatest(ActionTypes.EDITOR_BLOCK_DELETE_REQUEST, deleteBlock),
    takeLatest(ActionTypes.EDITOR_BLOCK_REORDER_REQUEST, reorderBlock),
    takeLatest(ActionTypes.EDITOR_BLOCK_SYNC_REQUEST, syncBlock),
    takeLatest(ActionTypes.EDITOR_COLOR_UPDATE_REQUEST, updateColor),
    takeLatest(ActionTypes.EDITOR_FONT_UPDATE_REQUEST, updateFont),
    takeLatest(ActionTypes.EDITOR_SEO_UPDATE_REQUEST, updateSeo),
    takeLatest(ActionTypes.EDITOR_GID_UPDATE_REQUEST, updateAnalytics),
    takeLatest(ActionTypes.EDITOR_BLOCK_RENAME_REQUEST, renameBlock),
    takeLatest(ActionTypes.EDITOR_PUBLISH_REQUEST, publish),
  ]);
}



// WEBPACK FOOTER //
// ./scripts/sagas/editor.js